import styled from 'styled-components';
import { IoIosMenu } from 'react-icons/io';
import { IconType } from 'react-icons';

const Container = styled.div<{ $blockColor?: string }>`
  width: 100%;
  min-height: 34px;
  height: 34px;
  border: 1px solid ${(props) => props.$blockColor ?? props.theme.global.borderColor};
  background-color: ${(props) => props.theme.global.bgColor};
  border-left-width: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  overflow: hidden;
  cursor: grab;
`;

const LeftView = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;

  svg {
    font-size: 16px;
  }

  img {
    width: 18px;
  }
`;

const IconView = styled.div`
  min-width: 24px;
  display: flex;
  align-items: center;
`;

const Name = styled.span`
  display: block;
  flex: 1;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
`;

const MenuIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  min-width: 20px;
`;

interface MenuBlockProps {
  iconPath?: string;
  name: string;
  blockColor?: string;
  Icon?: IconType;
  onDragStart: (event: React.DragEvent) => void;
}

const MenuBlock = ({ iconPath, name, blockColor, Icon, onDragStart }: MenuBlockProps) => {
  return (
    <Container draggable $blockColor={blockColor} onDragStart={onDragStart}>
      <LeftView>
        <IconView>
          {Icon && <Icon />}
          {iconPath && <img src={iconPath} alt={`${name}`} />}
        </IconView>
        <Name>{name}</Name>
      </LeftView>
      <MenuIcon>
        <IoIosMenu />
      </MenuIcon>
    </Container>
  );
};

export default MenuBlock;
